import { company_name } from "../../variables";

const sign_in = {
	/* -------------------------------------------------------------------------- */
	/*                            ACTIVATE ACCOUNT PAGE                           */
	/* -------------------------------------------------------------------------- */
	activate: {
		description: "Voltooi de registratie van uw account door een wachtwoord aan te maken.",
		status: {
			expired: {
				description:
					"De activatie link is verlopen en kan niet worden gebruikt. Vraag uw account administrator om een nieuwe uitnodiging.",
				title: "Activatielink verlopen!",
			},
			invalid: {
				description:
					"Uw verzoek om uw account te activeren is afgewezen, controleer uw link of neem contact met ons op bij aanhoudende problemen.",
				title: "Account niet geactiveerd!",
			},
			success: {
				description: "Uw account is actief en u kunt vanaf nu inloggen.",
				title: "Uw definitieve gebruikersnaam is <strong>{{username}}</strong> geworden!",
			},
			unknown: {
				description:
					"Er is iets misgegaan tijdens het toevoegen van een nieuwe gebruiker, probeer het nogmaals of neem contact op op met onze support afdeling.",
				title: "Account niet geactiveerd!",
			},
		},
		title: "Registratie voltooien",
	},

	/* -------------------------------------------------------------------------- */
	/*                           DEBLOCK IP-ADDRESS PAGE                          */
	/* -------------------------------------------------------------------------- */
	deblock_ip: {
		status: {
			expired: {
				description:
					"Uw aanvraag is verlopen en de link is niet meer geldig. U kunt opnieuw wachtwoordherstel aanvragen.",
				title: "Aanvraag verlopen!",
			},
			invalid: {
				description:
					"De door u ingevoerde deblokkeer-link is ongeldig en wordt niet door ons herkend.",
				title: "Deblokkeer link ongeldig!",
			},
			success: {
				description:
					" Uw IP-adres is succesvol gedeblokkeerd, u kunt voortaan weer inloggen vanaf uw IP-address.",
				title: "IP-adres succesvol gedeblokkeerd!",
			},
			unknown: {
				description:
					" Er is iets misgegaan waardoor wij uw IP-adres niet kunnen deblokkeren. Neem contact op met support.",
				title: "IP-adres deblokkeren mislukt!",
			},
		},
		title: "IP-adres deblokkeren",
	},

	/* -------------------------------------------------------------------------- */
	/*                           FORGAT PASSWORD SECTION                          */
	/* -------------------------------------------------------------------------- */
	forgot_password: {
		confirmation: {
			description:
				"Wanneer uw gebruikersnaam bij ons bekend is, zult u per mail een link ontvangen waarmee u een nieuw wachtwoord kan instellen. Heeft u geen e-mail ontvangen? Controleer dan uw spamfilter.",
			title: "Email verzonden",
		},
		description:
			"Vul de gebruikersnaam in en u ontvangt een e-mail met een daarin een link om uw wachtwoord te herstellen.",
		disabled_user: {
			description:
				"Wanneer uw gebruikersnaam bij ons bekend is, zult u per mail een link ontvangen waarmee u een nieuw wachtwoord kan instellen. Heeft u geen e-mail ontvangen, dan is uw gebruikersnaam mogelijk niet bij ons bekend.",
		},
		hostfact_user: {
			description:
				"U probeert in te loggen met een klanten.tuxis.nl account. Wellicht is er een persoonlijk account aangemaakt. Log daar dan mee in. Is dit de eerste keer dat u inlogt op deze Portal met uw klanten.tuxis.nl gegevens, herstel dan uw wachtwoord op https://klanten.tuxis.nl.",
		},
		title: "Wachtwoord vergeten?",
	},

	/* -------------------------------------------------------------------------- */
	/*                          FORGOT USER NAME SECTION                          */
	/* -------------------------------------------------------------------------- */
	forgot_username: {
		confirmation: {
			description:
				"Wanneer uw e-mail bij ons bekend is zal u per mail uw gebruikersnaam ontvangen. Heeft u geen e-mail ontvangen? Controleer dan uw spamfilter",
			title: "Email verzonden",
		},
		description:
			"Vul het e-mailadres in dat u gebruikt op dit portaal en u ontvangt een lijst met alle geregistreerde gebruikersnamen die aan dit e-mailadres zijn gekoppeld.",
		title: "Gebruikersnaam vergeten?",
	},
	/* -------------------------------------------------------------------------- */
	/*                                SIGN IN PAGE                                */
	/* -------------------------------------------------------------------------- */
	index: {
		confirm_email: {
			button: "Naar homepagina",
			message:
				"Er is een bevestigingsmail verzonden naar <strong>{{email_address}}</strong> ter validatie van het adres. Deze mail bevat instructies om uw e-mailadres te valideren en alle details van de bevestiging die u nodig heeft. Het is belangrijk dat u de validatie uitvoert om ervoor te zorgen dat we uw aanvraag kunnen verwerken.",
			title: "E-mailadres bevestigingen",
		},
		form: {
			description:
				"Om toegang te krijgen tot het portaal, dient u in te loggen met uw gebruikersnaam en wachtwoord.",
			links: {
				forgot_password: "Wachtwoord vergeten?",
				forgot_username: "Gebruikersnaam vergeten?",
				new_user: {
					part1: `Nog geen klant van ${company_name}?`,
					part2: "Maak een account aan!",
				},
			},
			register: {
				title: "Maak een account aan",
			},
			title: "Inloggen",
		},
		modal: {
			description:
				"2FA is ingesteld op uw account. Vul uw autorisatie code in om toegang te krijgen tot het portal.",
			title: "Tweestapsverificatie (2FA)",
		},
		section: {
			description: {
				href: "https://support.tuxis.nl/nl/knowledgebase/article/uw-klanten-tuxis-nl-account-gebruiken-en-overzetten-naar-portal-tuxis-cloud-portal",
				text: "In Portal kunt u producten bestellen en beheren. Maak voor uzelf, medewerkers en/of externe een gratis persoonlijk account aan. Zo kunt u regelen dat iemand bijv. wel een VPS kan aanmaken maar, geen facturen kan inzien. Ook kunt u producten koppelen aan relaties zodat u altijd weet welke afdeling of klant een bepaald product of dienst gebruikt.<br/><br/>Bestaande klant en nieuw bij deze portal? Lees <a>hier</a> wat u moet doen om de eerste keer in te kunnen loggen op Portal. Nieuwe klant? Klik dan op registreren.",
			},
			title: "High-end oplossingen voor ambitieuze bedrijven",
		},
		status: {
			debtor_blocked: "Debiteur geblokkeerd. Neem contact op met onze support afdeling.",
			email_resend: "Gelukt! We hebben u een nieuwe bevestigingsmail opgestuurd.",
			expired_hostfact_user: {
				msg: {
					href: "https://support.tuxis.nl/nl/tickets/create/step1",
					text: "U probeert in te loggen met uw klanten.tuxis account. Aangezien er al een persoonlijk account aangemaakt is, dient u deze te gebruiken om in te loggen. Hebt u nog geen persoonlijk account, neem dan contact op met de collega die mogelijk wel een persoonlijk account heeft. Weet u niet wie dit is? Vraag het dan via een ticket op <a>support.tuxis.nl</a>.",
				},
				title: "Persoonlijk account gebruiken",
			},
			hostfact_debtor_mapping_issue:
				"Op dit moment lukt het niet om in te loggen met uw bestaande debiteurnummer. Neem contact op met onze support afdeling.",
			inactive:
				"U moet uw e-mailadres bevestigingen voordat uw toegang kan krijgen tot uw account.",
			invalid: "Uw gebruikersnaam of wachtwoord is onjuist.",
			invalid_format:
				'Foutcode: Gebruikersnaam voldoet niet aan gewenste formaat. Gebruik "username@DBxxxx" met xxxx als debiteurnummer.',
			open_invite:
				"U heeft uw account nog niet geactiveerd, dit kan u doen door op de link in de mail te klikken die u van ons heeft ontvangen. Geen mail ontvangen? Neem contact op met uw account administrator.",
			user_blocked: "Debiteur geblokkeerd. Neem contact op met uw administrator.",
			user_blocked_by_ip: {
				part_1: "Uw IP-adres is geblokkeerd wegens teveel foutieve inlogpogingen.",
				part_2: "Uw account deblokkeren",
			},
		},
	},

	/* -------------------------------------------------------------------------- */
	/*                             RESET PASSWORD PAGE                            */
	/* -------------------------------------------------------------------------- */
	password_reset: {
		description:
			"Uw kunt nu een nieuw wachtwoord instellen, na het instellen komt uw oude wachtwoord te vervallen.",
		error_messages: {
			no_match: "Uw wachtwoorden komen niet overeen!",
		},
		status: {
			expired: {
				description:
					"Uw verzoek is verlopen en de link is niet meer geldig. U kunt opnieuw wachtwoordherstel aanvragen.",
				title: "Verzoek verlopen!",
			},
			invalid: {
				description:
					"Uw verzoek om uw wachtwoord te wijzigen is afgewezen, controleer uw link of neem contact met ons op bij aanhoudende problemen.",
				title: "Verzoek geweigerd!",
			},
			not_allowed: {
				description:
					"Het wachtwoord van een HostFact gebruiker kan niet via het Portal worden gewijzigd. Dit moet via HostFact gebeuren.",
				title: "HostFact wachtwoord kan niet worden gewijzigd!",
			},
			success: {
				description:
					"Uw wachtwoord is succesvol gewijzigd, u kunt nu inloggen met uw nieuwe wachtwoord",
				title: "Wachtwoord succesvol gewijzigd",
			},
			unknown: {
				description:
					"Uw verzoek om uw wachtwoord te wijzigen is afgewezen, controleer uw link of neem contact met ons op bij aanhoudende problemen.",
				title: "Verzoek geweigerd!",
			},
		},
		title: "Wachtwoord opnieuw instellen",
	},

	/* -------------------------------------------------------------------------- */
	/*                           REQUEST DEBLOCK SECTION                          */
	/* -------------------------------------------------------------------------- */
	request_deblock_link: {
		confirmation: {
			description:
				"Wanneer uw e-mail bij ons bekend is zal u per mail een link ontvangen waarmee u uw account kan deblokkeren. Heeft u geen e-mail ontvangen? Controleer dan uw spamfilter",
			title: "Email verzonden",
		},
		description:
			"Uw IP-adres is geblokkeerd wegens teveel foutieve inlogpogingen. U kunt uw account deblokkeren door hieronder uw gebruikersnaam in te vullen. U ontvangt een mail met daarin een link om te deblokkeren.",
		title: "IP-adres deblokkeren",
	},
};

export default sign_in;
